/* tslint:disable */
/* eslint-disable */
/**
 * Legalscape REST API
 * Internal API for use from web
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { EGovPublicCommentURL } from '../model';
/**
 * EGovApi - axios parameter creator
 * @export
 */
export const EGovApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * EGov上のパブリックコメントの案件番号を受け取ってEGov上のURLを返す。 ただし、EGov上に存在しない場合もエラーにはならず過去案件としてURLを返す（この場合、foundがfalseになる） 
         * @summary EGov上のパブリックコメントの案件番号を受け取ってEGov上のURLを返す。
         * @param {string} id EGov上のパブリックコメントの案件番号
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEGovPublicCommentURL: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getEGovPublicCommentURL', 'id', id)
            const localVarPath = `/e-gov/public-comment/{id}/url`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EGovApi - functional programming interface
 * @export
 */
export const EGovApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EGovApiAxiosParamCreator(configuration)
    return {
        /**
         * EGov上のパブリックコメントの案件番号を受け取ってEGov上のURLを返す。 ただし、EGov上に存在しない場合もエラーにはならず過去案件としてURLを返す（この場合、foundがfalseになる） 
         * @summary EGov上のパブリックコメントの案件番号を受け取ってEGov上のURLを返す。
         * @param {string} id EGov上のパブリックコメントの案件番号
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEGovPublicCommentURL(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EGovPublicCommentURL>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEGovPublicCommentURL(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * EGovApi - factory interface
 * @export
 */
export const EGovApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EGovApiFp(configuration)
    return {
        /**
         * EGov上のパブリックコメントの案件番号を受け取ってEGov上のURLを返す。 ただし、EGov上に存在しない場合もエラーにはならず過去案件としてURLを返す（この場合、foundがfalseになる） 
         * @summary EGov上のパブリックコメントの案件番号を受け取ってEGov上のURLを返す。
         * @param {string} id EGov上のパブリックコメントの案件番号
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEGovPublicCommentURL(id: string, options?: any): AxiosPromise<EGovPublicCommentURL> {
            return localVarFp.getEGovPublicCommentURL(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EGovApi - interface
 * @export
 * @interface EGovApi
 */
export interface EGovApiInterface {
    /**
     * EGov上のパブリックコメントの案件番号を受け取ってEGov上のURLを返す。 ただし、EGov上に存在しない場合もエラーにはならず過去案件としてURLを返す（この場合、foundがfalseになる） 
     * @summary EGov上のパブリックコメントの案件番号を受け取ってEGov上のURLを返す。
     * @param {string} id EGov上のパブリックコメントの案件番号
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EGovApiInterface
     */
    getEGovPublicCommentURL(id: string, options?: AxiosRequestConfig): AxiosPromise<EGovPublicCommentURL>;

}

/**
 * EGovApi - object-oriented interface
 * @export
 * @class EGovApi
 * @extends {BaseAPI}
 */
export class EGovApi extends BaseAPI implements EGovApiInterface {
    /**
     * EGov上のパブリックコメントの案件番号を受け取ってEGov上のURLを返す。 ただし、EGov上に存在しない場合もエラーにはならず過去案件としてURLを返す（この場合、foundがfalseになる） 
     * @summary EGov上のパブリックコメントの案件番号を受け取ってEGov上のURLを返す。
     * @param {string} id EGov上のパブリックコメントの案件番号
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EGovApi
     */
    public getEGovPublicCommentURL(id: string, options?: AxiosRequestConfig) {
        return EGovApiFp(this.configuration).getEGovPublicCommentURL(id, options).then((request) => request(this.axios, this.basePath));
    }
}
